<template>
  <div class="coupon">
    <van-nav-bar
      title="超级会员"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      :fixed="true"
    />
    <div
      class="vip"
      v-show="vipfalge"
    >
      <div class="top clearfix">
        <div class="left clearfix fl">
          <div class="imgs fl">
            <img
              src="../../../assets/dwdew.png"
              alt=""
            >
          </div>
          <div class="user fl">
            <div class="name">货空间</div>
            <div class="super">超级会员</div>
          </div>
        </div>
        <div class="right fr">
          <div
           
            class="aging"
          >
            <!-- 续费> -->
            有效期至 
          </div>
          <div class="time">
            <span>{{time}}</span>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="coupons fl">
          <div class="title">单单买，单单省</div>
          <!-- <div class="title">可领全品类券</div> -->
          <!-- <div class="money"><span>10000</span>元</div> -->
          <!-- <div
            class="but"
            @click="collect"
          >领取</div> -->
        </div>
        <div class="coupons fl">
          <!-- <div class="title">可领运费券</div> -->
          <!-- <div class="money"><span>0</span>张</div> -->
          <!-- <div class="but">领取</div> -->
        </div>
        <div
          class="coupons fr"
          v-show="false"
        >
          <div class="title">可为你节省</div>
          <div class="money"><span>10000</span>元</div>
          <div
            class="but"
            @click="discoupen"
          >查看</div>
        </div>
      </div>
    </div>
    <div
      class="open"
      v-show="!vipfalge"
    >
      <div class="user clearfix">
        <div class="img fl">
          <img
            src="../../../assets/user.png"
            alt=""
          >
        </div>
        <div class="name fl">货空间</div>
      </div>
      <div class="centen">
        <ul>
          <li class="clearfix">
            <div class="left fl">服务名称</div>
            <div v-if='$store.state.shopid==27' class="right fr">超级会员(常州店)</div>
            <div v-else class="right fr">超级会员</div>
            
          </li>
          <li class="clearfix">
            <div class="left fl">开通时长</div>
            <div class="right fr">12个月</div>
          </li>
          <li class="clearfix">
            <div class="left fl">应付金额</div>
            <div class="right fr"><span v-if="$store.state.shopid==27">￥5000</span><span v-else>￥10000</span></div>
          </li>
        </ul>
        <div class="agree">
          <van-radio-group v-model="radio">
            <van-radio name="1"><span style="font-size:14px">我已阅读并同意</span><span
                @click.stop="gox"
                style="font-size:14px;color:#2222dd"
              >《会员协议》</span></van-radio>
          </van-radio-group>
        </div>
        <div class="but">
          <van-button
            type="primary"
            size="large"
            color="#c5b48e"
            @click="gocashier"
          ><span style="font-size:14px">立即续费</span></van-button>
        </div>
        <div class="explain">
          超级会员服务一经开通 不支持取消/退款，敬请谅解
        </div>
      </div>
    </div>
    <div v-if='$store.state.shopid==27' class="vips">
      <img
        src="../../../assets/cvip.jpg"
        alt=""
      >
    </div>
    <div v-else class="vips">
      <img
        src="../../../assets/membervip.jpeg"
        alt=""
      >
    </div>
    <!-- 领优惠劵 -->
    <van-popup
      v-model="show"
      closeable
      position="bottom"
      close-icon="cross"
      :style="{ height: '60%' }"
    >
      <div class="collect">
        <div class="title">领券</div>
        <div class="coupenlist">
          <div
            class="list clearfix"
            v-for="v in 10"
            :key="v"
          >
            <div class="c-left fl">
              <div class="c-top">￥<span>100.00</span>超级会员专享优惠券</div>
              <div class="c-bottom">有效期<span>2019.01.02</span>-<span>2019.02.01</span></div>
            </div>
            <div
              class="c-right fr"
              @click="receive"
            >立即领取</div>
            <div class="xian"></div>
            <div class="yuan"></div>
            <div class=" two"></div>
            <div class="already">
              <img
                src="../../../assets/receive@2x.png"
                alt=""
              >
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 优惠详情 -->
    <van-popup
      v-model="deshow"
      closeable
      close-icon="cross"
      :close-on-click-overlay="false"
      :style="{ height: '60%',width:'90%' }"
    >
      <div class="details">
        <div class="heard">
          <p style="font-size:19px">超级会员省全计算器</p>
          <p>自您2019-09-29成为超级会员</p>
        </div>
        <div class="nav">
          <div class="det-left">
            <p>共消费</p>
            <p>￥<span>1000</span></p>
          </div>
          <div class="det-right">
            <p>超级会员为您节省</p>
            <p>￥<span>1</span></p>
          </div>
        </div>
        <div class="content">
          <div class="c-list">
            <div class="c-left">
              <p>购物返利</p>
              <p style="color:#999">已获反馈总价值</p>
            </div>
            <div class="c-right">￥349.00</div>
          </div>
          <div class="c-list">
            <div class="c-left">
              <p>节省运费</p>
              <p style="color:#999">已使用运费劵总价值</p>
            </div>
            <div class="c-right">￥349.00</div>
          </div>
          <div class="c-list">
            <div class="c-left">
              <p style="font-weight:700">超级会员已为您节省</p>
            </div>
            <div
              class="c-right"
              style="font-weight:700"
            >￥349.00</div>
          </div>
          <div class="bont">
            <van-button
              type="primary"
              @click="go"
              size="large"
            >继续逛逛</van-button>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import Vue from 'vue';
import { NavBar, Toast, Button, Icon, Tab, Tabs, RadioGroup, Radio, Popup } from 'vant';

Vue.use(NavBar).use(Toast).use(Button).use(Icon).use(Tab).use(Tabs).use(RadioGroup).use(Radio).use(Popup)
export default {
  created () {
    if (JSON.parse(localStorage.getItem('vip')).id != 0) {
      this.vipfalge = true
    } else {
      this.vipfalge = false
    }
    this.axios.post('userInfo', { store_id: this.$store.state.shopid, }).then(res => {

      if (res.data.code == 200) {
        console.log(res)

        let data = new Date(res.data.info.end_time * 1000)
        let year = data.getFullYear()
        // console.log(1)
        let month = data.getMonth() + 1
        let day = data.getDate()
        month = month < 10 ? '0' + month : month
        day = day < 10 ? "0" + day : day
        console.log()
        this.time = year + "-" + month + "-" + day
      }
    }).catch(ref => { })
  },
  data () {
    return {
      active: 0,
      radio: 0,
      vipfalge: false,
      show: false,
      deshow: false,
      time: ''
    }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    gocashier () {
      if (this.radio == 1) {
        this.$router.push({ name: 'cashier', query: { money:this.$store.state.shopid==27?5000: 10000, from: "vip" } })

      } else {
        Toast("请先同意会员协议")
      }
    },
    gox () {
      this.$router.push({ name: 'xie' })

    },
    collect () {
      Toast('以发放优惠券')
      return
      this.show = true
    },
    xun () {
      this.$router.push({ name: 'cashier', query: { money: 10000 } })
    },
    receive () {
    },
    discoupen () {
      this.deshow = true
    },
    go () {
      // this.location.href = 'https://m.eqxiu.com/s/ALP0kUQv'
    }
  }
}
</script>
<style >
.van-nav-bar__text {
  color: #000;
}
.van-nav-bar .van-icon {
  color: #000;
}
.van-popup__close-icon--top-right {
  top: 0.3rem;
}
</style>
<style lang="less" scoped>
.coupon {
  padding-top: 1.33rem;
}
.vip {
  margin: 0.45rem;
  background-color: #404040;
  height: 5.92rem;
  border-radius: 2.5%;
  color: #e1d1ad;
}
.top {
  padding-top: 0.4rem;
  padding-left: 0.5rem;
  .left {
    .imgs {
      width: 1.1rem;
      height: 1.1rem;
      border-radius: 50%;
      background-color: #575757;
      padding-top: 0.29rem;
      img {
        margin: 0 auto;

        width: 0.5rem;
      }
    }
    .user {
      color: #e1d1ad;
      padding-left: 0.2rem;
      .name {
        padding-left: 0.1rem;
        font-size: 0.346667rem;
      }
      .super {
        width: 1.72rem;
        height: 0.506667rem;
        text-align: center;
        border-radius: 0.5rem;
        border: 1px solid #e1d1ad;
      }
    }
  }
  .right {
    width: 3.5rem;
    height: 1.2rem;
    border-radius: 0.7rem 0 0 0.7rem;
    background-color: #ddcca8;
    padding-left: 0.45rem;
    padding-top: 0.2rem;
    color: #4c3a1d;
  }
}
.bottom {
  padding-top: 0.85rem;
  padding-left: 0.5rem;
  .coupons {
    padding-right: 0.75rem;
    font-size: 0.346667rem;
    .title {
      padding-bottom: 0.3rem;
    }
    .money {
      span {
        font-size: 0.55rem;
        padding-right: 0.1rem;
      }
    }
    .but {
      margin-top: 0.5rem;
      width: 1.44rem;
      height: 0.56rem;
      text-align: center;
      line-height: 0.56rem;
      border-radius: 0.5rem;
      background: -webkit-linear-gradient(left, #d8c7a2 0%, #eedcba 100%);
      color: #665734;
    }
  }
}
.open {
  background-color: #f1efeb;
  padding-bottom: 0.15rem;
  .user {
    padding: 0.25rem 0.43rem;
    padding-bottom: 0rem;
    .img {
      width: 1.13rem;
    }
  }
  .name {
    font-size: 0.45rem;
    padding-left: 0.2rem;
    line-height: 1.1rem;
  }
  .centen {
    margin: 0.3rem;
    background-color: #fff;
    height: 8rem;
    border-radius: 1%;
    padding: 0.2rem 0.4rem;
    li {
      border-bottom: 1px solid #ccc;
      height: 1.333333rem;
      line-height: 1.3333rem;
      .left,
      .right {
        font-size: 0.4rem;
        span {
          color: #a22d2b;
          font-size: 0.45rem;
        }
      }
    }
    .agree {
      padding: 0.6rem 0.8rem 0.4rem 0.8rem;
    }
    .but {
      border-radius: 0.15rem;
      overflow: hidden;
    }
    .explain {
      padding-top: 0.15rem;
      color: #999;
      padding-left: 0.2rem;
    }
  }
}
.collect {
  .title {
    text-align: center;
    border-bottom: 1px solid #eee;
    height: 1.25rem;
    line-height: 1.25rem;
    font-size: 0.4rem;
  }
  .coupenlist {
    padding: 0.2rem;
    .list {
      position: relative;
      margin-top: 0.3rem;
      height: 2.55rem;
      background-color: #fde9e9;
      padding: 0.26rem;
      color: #dc7676;
      .c-left {
        .c-top {
          padding-top: 0.2rem;
          padding-bottom: 0.2rem;
          font-size: 0.374rem;
          span {
            font-size: 0.65rem;
          }
        }
      }
      .c-right {
        font-size: 0.4rem;
        line-height: 2rem;
        padding-right: 0.2rem;
      }
      .xian {
        position: absolute;
        width: 1px;
        left: 7rem;
        border-left: 1px dashed #333;
        height: 2rem;
      }
      .yuan {
        position: absolute;
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 50%;
        top: -0.2rem;
        z-index: 99;
        background-color: #fff;
        left: 6.8rem;
      }
      .two {
        bottom: -0.2rem;
        position: absolute;
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 50%;
        z-index: 99;
        background-color: #fff;
        left: 6.8rem;
      }
      .already {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 1.34rem;
        height: 1.1rem;
      }
    }
  }
}
.details {
  .heard {
    background-color: #b2a487;
    height: 2rem;
    text-align: center;
    color: #fff;
    padding-top: 0.45rem;
    p {
      line-height: 0.65rem;
    }
  }
  .nav {
    height: 1.6rem;
    background-color: #f99;
    display: flex;
    color: #d0ad69;
    text-align: center;
    .det-left {
      flex: 0.4;
      background-color: #2f3164;
      padding-top: 0.3rem;
      p {
        line-height: 0.5rem;
      }
    }
    .det-right {
      padding-top: 0.3rem;
      p {
        line-height: 0.5rem;
      }
      flex: 0.6;
      background-color: #d0ad69;
      color: #2f3164;
    }
  }
  .content {
    height: 1.4rem;
    .c-list {
      padding: 0.3rem;
      display: flex;
      .c-left {
        flex: 0.4;
        p {
          line-height: 0.5rem;
        }
      }
      .c-right {
        flex: 0.6;
        text-align: right;
        padding-right: 0.3rem;
      }
    }
  }
}
.vips {
  margin: 0.2rem;
}
</style>